import * as React from 'react';

function CredentialIcon({ color = '#545454', ...props }) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={16} height={16} viewBox='0 0 19 22' fill='none' {...props}>
			{/* original icon */}
			<path
				d='M11.4214 20.7332H6.84717C6.01793 20.7332 5.3457 20.0099 5.3457 19.1178V6.19495C5.3457 5.30281 6.01793 4.57959 6.84717 4.57959H15.856C16.6852 4.57959 17.3574 5.30281 17.3574 6.19495V10.9172'
				stroke={color}
				strokeWidth={2}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path d='M8.66602 7.85156H10.8379' stroke={color} strokeWidth={2} strokeLinecap='round' />
			<path
				d='M9.15287 4.0611C8.19471 0.393468 3.97361 0.890241 2.63308 2.42128C0.36423 5.01255 2.80327 6.85076 2.0947 12.0913'
				stroke={color}
				strokeWidth={2}
				strokeLinecap='round'
			/>

			{/* 4x4 plus at bottom-right */}
			<path d='M14 18H18' stroke={color} strokeWidth={2} strokeLinecap='round' strokeLinejoin='round' />
			<path d='M16 16V20' stroke={color} strokeWidth={2} strokeLinecap='round' strokeLinejoin='round' />
		</svg>
	);
}

export default CredentialIcon;
